/**
 * Order personalisable navigation items by visit frequency without mutating
 * the source array. Leading/trailing anchors retain their familiar positions,
 * while ties in the personalisable middle preserve the design order.
 */
export const rankNavigationItems = (
  navigation,
  scores = {},
  fixedLeadingItemKeys = [],
  fixedTrailingItemKeys = []
) => {
  if (!Array.isArray(navigation) || navigation.length === 0) return [];

  const leadingKeys = new Set(fixedLeadingItemKeys);
  const trailingKeys = new Set(fixedTrailingItemKeys);
  const fixedItems = new Set([...leadingKeys, ...trailingKeys]);
  const leadingItems = navigation.filter((item) => leadingKeys.has(item.analyticsKey));
  const trailingItems = navigation.filter((item) => trailingKeys.has(item.analyticsKey));
  const rankableItems = navigation
    .map((item, defaultIndex) => ({ item, defaultIndex }))
    .filter(({ item }) => !fixedItems.has(item.analyticsKey))
    .sort((left, right) => {
      const leftScore = Number(scores[left.item.analyticsKey]) || 0;
      const rightScore = Number(scores[right.item.analyticsKey]) || 0;
      return rightScore - leftScore || left.defaultIndex - right.defaultIndex;
    })
    .map(({ item }) => item);

  return [...leadingItems, ...rankableItems, ...trailingItems];
};

export default rankNavigationItems;
